import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../request.js";
import { parseUrl as o, encode as r, asValidOptions as s } from "../utils.js";
import n from "../support/SuggestionCandidate.js";
import e from "../support/SuggestLocationsParameters.js";

function u(_x, _x2, _x3) {
  return _u.apply(this, arguments);
}

function _u() {
  _u = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(n, u, m) {
    var p, a, f, g, c;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            p = o(n), a = _objectSpread(_objectSpread({}, (u = e.from(u)).toJSON()), {}, {
              f: "json"
            }), f = r(_objectSpread(_objectSpread({}, p.query), a)), g = s(f, m), c = "".concat(p.path, "/suggest");
            return _context.abrupt("return", t(c, g).then(i));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _u.apply(this, arguments);
}

function i(t) {
  var o = t.data;
  if (!o) return [];
  var r = o.suggestions;
  return r ? r.map(function (t) {
    return new n(t);
  }) : [];
}

export { u as suggestLocations };